<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Vasundhra",
        para: "I did the UI design for the website of Vasundhra Jewellers. With UI typography, minimal design & subtle animations, we tried bringing an aesthetic feel & smooth user journey throughout the website. Kudos to the development & content team at Cobold who did justice to the design made.",
        company: "Vasundhra Jewellers",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/vasundhra/cover.jpg",
        TwoImgleft: "/img/gallery/ui/vasundhra/twoimg.svg",
        TwoImgRight: "/img/gallery/ui/vasundhra/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/vasundhra/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/vasundhra/threeright.svg",
        coverimg2: "",
      },
    };
  },
};
</script>
